import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { defaultProductImageZoomLayoutConfig } from '@spartacus/product/image-zoom/components';
import {
  CarouselModule,
  DIALOG_TYPE,
  IconModule,
  KeyboardFocusModule,
  LayoutConfig,
  MediaModule,
  OutletModule,
} from '@spartacus/storefront';
import { KbProductImageZoomProductImagesComponent } from './kb-product-image-zoom.component';
import { KbProduct360ViewImageZoomDialogComponent } from './product-360view-image-zoom-dialog/product-360view-image-zoom-dialog';
import { KbProductImageZoomDialogComponent } from './product-image-zoom-dialog/product-image-zoom-dialog.component';
import { KbProductImageZoomThumbnailsComponent } from './product-image-zoom-thumbnails/product-image-zoom-thumbnails.component';
import { KbProductImageZoomTriggerComponent } from './product-image-zoom-trigger/product-image-zoom-trigger.component';
import { KbProductImageZoomViewComponent } from './product-image-zoom-view/product-image-zoom-view.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbCustomImageZoomModule } from './kb-custom-image-zoom/kb-custom-image-zoom/kb-custom-image-zoom.module';

@NgModule({
  imports: [
    CarouselModule,
    CommonModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
    MediaModule,
    OutletModule,
    RouterModule,
    KbCustomImageZoomModule
  ],
  declarations: [
    KbProductImageZoomDialogComponent,
    KbProductImageZoomProductImagesComponent,
    KbProductImageZoomThumbnailsComponent,
    KbProductImageZoomTriggerComponent,
    KbProductImageZoomViewComponent,
    KbProduct360ViewImageZoomDialogComponent,
    
  ],
  exports: [
    KbProductImageZoomDialogComponent,
    KbProductImageZoomProductImagesComponent,
    KbProductImageZoomThumbnailsComponent,
    KbProductImageZoomTriggerComponent,
    KbProductImageZoomViewComponent,
    KbProduct360ViewImageZoomDialogComponent,
    
  ],
  providers: [
    provideConfig(defaultProductImageZoomLayoutConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductImagesComponent: {
          component: KbProductImageZoomProductImagesComponent,
        },
      },
    }),
    provideConfig(<LayoutConfig>{
      launch: {
        PRODUCT_360View_IMAGE_ZOOM: {
          inline: true,
          component: KbProduct360ViewImageZoomDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
          guards: [SecureGuard, AuthGuard]
        },
      },
    })
  ],
})
export class KbProductImageZoomModule { }
